import {AFD} from 'devegram-javascript-util'

const baseUrl = '/xapi/Voip/Broadcast';
const baseUrl2 = '/xapi/VoipMrt/Broadcast';
const moduleAjaxService = 'backend-service'
const api = {
    namespaced: true,
    state: {},
    actions: {
        async getUsersFusionServer(context, records) {
            let api = {
                verb: 'POST',
                service: moduleAjaxService,
                url: baseUrl + '/getUsersFusionName',
                data: records
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getBroadcastHistory(context, params) {
            let userId = 'user_id=' + params.userId
            let statusId = '&status_id=' + params.statusId
            let page = '&page=' + params.page
            let division = '&division=' + params.division
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getBroadcastHistory?' + userId + statusId + page + division,
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getMrtBroadcastHistory(context, params) {
            let userId = 'user_id=' + params.userId
            let statusId = '&status_id=' + params.statusId
            let page = '&page=' + params.page
            let division = '&division=' + params.division
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl2 + '/getBroadcastHistory?' + userId + statusId + page + division,
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getRatePanelInfo(context, params) {
            let rateId = params.rateId
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getRatePanelInfo?rate_id=' + rateId,
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getBroadcastCdr(context, params) {
            let live = false;
            if (params.hasOwnProperty('live') && params['live']) {
                live = true
            }
            let baseToUse = baseUrl
            if (params.hasOwnProperty('mrt')) {
                baseToUse = baseUrl2
            }

            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseToUse + '/getBroadcastCdr/' + params.id,
                noLoadingScreen: true
            };

            if (live) {
                api.timeout = 3000
            }

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        }, async getBroadcastCdrByPublicId(context, params) {
            let baseToUse = baseUrl
            if (params.hasOwnProperty('mrt')) {
                baseToUse= baseUrl2
            }
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseToUse + '/getBroadcastCdrByPublicId?id=' + params.publicId,
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getUserTestingPanelSetting(context) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getUserTestingPanelSetting',
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async getUserTestingPanelTestTypes(context) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/getUserTestingPanelTestTypes',
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async panelUserTest(context, params) {

            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/panelUserTest',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async panelUserTestMRT(context, params) {

            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl2 + '/panelUserTest',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async create(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/store',
                data: AFD(params.data)
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                })
            })
        },
        async update(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/update/' + params.id,
                data: AFD(params.data),
                noLoadingScreen: true
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async remove(context, params) {
            let api = {
                verb: 'post',
                service: moduleAjaxService,
                url: baseUrl + '/remove/' + params.id
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async get(context, params) {
            let page = (params.page) ? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/get/' + params.id + '?page=' + page
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async list(context, params) {
            let page = (params.page) ? params.page : 1
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/list?page=' + page,
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        },
        async getDropDownList(context, params) {
            let api = {
                verb: 'get',
                service: moduleAjaxService,
                url: baseUrl + '/dropDownList',
                data: null
            };

            return new Promise((resolve, reject) => {
                context.dispatch('ajaxManager/api', api, {root: true}).then(r => {
                    resolve(r.data);
                }).catch(e => {
                    reject(e);
                });
            })
        }
    }

};

export default api
